export function formatNumber(number: number | Array<number>, num_decimals?: number, include_comma?: boolean) {
  if (typeof number !== "number" && number.length > 0) {
    number = number[0];
  }

  return number.toLocaleString("en-US", {
    useGrouping: include_comma,
    minimumFractionDigits: num_decimals,
    maximumFractionDigits: num_decimals,
  });
}

export function parseAmount(value: string) {
  return Number(value.replace(/[^\d.]/g, ""));
}

export function formatAmount(value: string) {
  const amount = parseAmount(value);
  return /\d/.test(value) && Number.isFinite(amount) ? `$${formatNumber(amount, 0, true)}` : value;
}
